import { useFriendRequests } from "./hooks/useFriendRequests";
import RequestList from "./components/RequestList";
import "./friendrequests.scss";

const Friendrequests = () => {
  const { 
    requests, 
    isLoading, 
    error, 
    acceptRequest, 
    deleteRequest, 
    isAccepting, 
    isDeleting 
  } = useFriendRequests();

  return (
    <div className="friendrequest">
      <h3>
        Friend Requests
      </h3>
      
      <RequestList
        requests={requests}
        isLoading={isLoading}
        error={error}
        onConfirm={acceptRequest}
        onDelete={deleteRequest}
        isAccepting={isAccepting}
        isDeleting={isDeleting}
      />
    </div>
  );
};

export default Friendrequests;